import { Component, OnInit, OnDestroy } from '@angular/core';
import { takeUntil } from 'rxjs/operators';
import { componentDestroyed } from '@w11k/ngx-componentdestroyed';
import * as moment from 'moment-timezone';
import { StaffService } from '../staffs/staff-service/staff.service';
import { SharedDataService } from 'src/app/service/shared-service/shared-data.service';
import { exportToCsv } from 'src/app/utils/utils.common';
import { DatePipe } from 'src/app/pipe/date-pipe/date.pipe';

@Component({
  selector: 'app-audit-logs',
  templateUrl: './audit-logs.component.html',
  styleUrls: ['./audit-logs.component.css']
})
export class AuditLogsComponent implements OnInit, OnDestroy {

  user;
  timeZone;
  staffList: any[] = [];
  activityLogs: any[] = [];
  selectedStaff = '';
  dateRange;

  constructor(
    private staffService: StaffService,
    private sharedDataService: SharedDataService,
    private dateP: DatePipe,
  ) { }

  ngOnInit() {
    this.getUser();
    this.getStaffList();
  }

  getUser() {
    this.sharedDataService
      .getUser()
      .pipe(takeUntil(componentDestroyed(this)))
      .subscribe(user => {
        if (user) {
          this.timeZone = user.timeZone;
          this.user = user;
          this.dateRange = [
            moment.tz(this.timeZone).startOf("day").toISOString(),
            moment.tz(this.timeZone).endOf("day").toISOString(),
          ];
        }
      });
  }

  getStaffList() {
    this.staffService
      .getStaffList()
      .pipe(takeUntil(componentDestroyed(this)))
      .subscribe(data => {
        if (data) {
          this.staffList = data;
          this.staffList.sort((a, b) =>
            a.displayName.localeCompare(b.displayName)
          ); 
        }
      });
  }

  onDateChange() {
    this.dateRange = [
      moment.tz(this.dateRange[0], this.timeZone).startOf('day').toISOString(),
      moment.tz(this.dateRange[1], this.timeZone).endOf('day').toISOString(),
    ];
    this.getActivityLogs();
  }

  onStaffChange() {
    this.getActivityLogs();
  }

  getActivityLogs() {
    if (!this.selectedStaff) {
      this.activityLogs = [];
      return;
    }

    const queryParams = {
      startTime: this.dateRange[0],
      endTime: this.dateRange[1]
    };
    this.staffService
      .getStaffActivityLogs(this.selectedStaff, queryParams)
      .pipe(takeUntil(componentDestroyed(this)))
      .subscribe(data => {
        if (data && data.activityLogs) {
          this.activityLogs = data.activityLogs;
        }
      });
  }
 

  downloadCsv() {
    if (!this.activityLogs.length) {
      return;
    }

    const table = [
      ['user', 'event', 'source', 'created_at', 'message'],
      ...this.activityLogs.map(log => [
        log.user || "",
        log.event || "",
        log.source || "",
        this.dateP.transform(log.createdAt, 'MM/DD/YYYY HHmm'),
        log.message || ""
      ])
    ];

    exportToCsv(`Audit_Logs_${moment.tz(this.timeZone).format('MM-DD-YYYY')}.csv`, table);
  }

  ngOnDestroy(): void {
  }
}
